import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeLabelOrderId = createAction('CHANGE_LABEL_ORDERID');
export const changeLabelEventKey = createAction('CHANGE_LABEL_EVENT_KEY');

export const changeCareLabelValue = createAction('CHANGE_CARELABEL_VALUE');

export const changeSpecialNotActivePage = createAction('CHANGE_SPECIAL_NOTE_ACTIVE_PAGE');

export const cleanLabelAlert = createAction('CLEAN_LABEL_ALERT');

export const findNoLabelGeneratedCount = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let orderId = payload.orderId;
      let url = '/firefighter/label/' + orderId + '/findNoLabelGeneratedCount';
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_NOLABEL_GENERATED_COUNT',
          payload: json
        });
      });
    }
  }
);

export const findSerialNoData = (payload) => (
  (dispatch) => {
    let orderId = payload.orderId;
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/label/' + orderId + '/findSerialNoData';
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_SERIALNO_DATA',
          payload: json
        });
      });
    }
  }
);

export const generateCareLabels = (careLabel) => (
  (dispatch) => {
    if (careLabel && careLabel.get('orderId') && !('' === careLabel.get('orderId'))) {

      dispatch({
        type: 'BEFORE_GENERATE_CARE_LABELS'
      });

      let orderId = careLabel.get('orderId');
      let url = '/firefighter/label/' + orderId + '/generateCareLabels';
      authFetch('POST', url, JSON.stringify(careLabel), (json) => {
        dispatch({
          type: 'GENERATE_CARE_LABELS',
          payload: json
        });
        dispatch(findNoLabelGeneratedCount({ orderId: orderId }));
        dispatch(findSerialNoData({ orderId: orderId }));
      });
    }
  }
);

export const deleteCareLabels = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {

      let orderId = payload.orderId;
      let url = '/firefighter/label/' + orderId + '/deleteCareLabels';
      authFetch('DELETE', url, null, (json) => {
        dispatch({
          type: 'DELETE_CARE_LABELS',
          payload: json
        });
        dispatch(findNoLabelGeneratedCount({ orderId: orderId }));
        dispatch(findSerialNoData({ orderId: orderId }));
      });
    }
  }
);

export const findSpecialNoteList = (payload, pagingData) => (
  (dispatch) => {
    let orderId = payload.orderId;
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/label/' + orderId + '/findSpecialNoteList?activePage=' + pagingData.activePage
        + '&itemPerPage=' + pagingData.itemPerPage;
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_SPECIAL_NOTE_LIST',
          payload: json
        });
      });
    }
  }
);

export const exportSpecialNoteList = (payload) => (
  (dispatch) => {
    let orderId = payload.orderId;
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/label/' + orderId + '/exportSpecialNoteList';
      authFetch('PUT', url, JSON.stringify({}), (json) => {
        dispatch({
          type: 'EXPORT_SPECIAL_NOTE_LIST',
          payload: json
        });
      });
    }
  }
);

export const findLabelById = (payload) => (
  (dispatch) => {
    let labelId = payload.labelId;
    if (labelId && !('' === labelId)) {
      let url = '/firefighter/label/orderLabelId/' + labelId;
      authFetch('GET', url, null, (json) => {
        assignDateString(json);
        dispatch({
          type: 'FIND_ORDER_LABEL',
          payload: json
        });
      });
    }
  }
);

export const editOrderLabel = (payload) => (
  (dispatch) => {
    let labelId = payload.labelId;
    let url = '/firefighter/label/orderLabelId/' + labelId;
    authFetch('PUT', url, JSON.stringify(payload), (json) => {
      assignDateString1(json);
      dispatch({
        type: 'EDIT_ORDER_LABEL',
        payload: json
      });
    });
  }
);

export const clearSpecialNoteDownloadUrl = createAction('CLEAR_SPECIAL_NOTE_DOWNLOADURL');
export const clearSerialNoDownloadUrl = createAction('CLEAR_SERIAL_NO_DOWNLOADURL');
export const changeLabelValue = createAction('CHANGE_LABEL_VALUE');
export const cleanOrderLabelAlert = createAction('CLEAN_ORDER_LABEL_ALERT');
export const cleanOrderLabelInput = createAction('CLEAN_ORDER_LABEL_INPUT');
export const changeLabelRestoreValue = createAction('CHANGE_LABEL_RESTORE_VALUE');

// 置換日期顯示
function assignDateString(json) {
  if (json.data.sManufactureDate)
    json.data.manufactureDate = json.data.sManufactureDate;
}

function assignDateString1(json) {
  if (json.data.bean.sManufactureDate)
    json.data.bean.manufactureDate = json.data.bean.sManufactureDate;
}

// 序號表下載
export const exportSerialNoList = (payload) => (
  (dispatch) => {
    let orderId = payload.orderId;
    if (orderId && !('' === orderId)) {
      let url = '/firefighter/label/' + orderId + '/exportSerialNoList';
      authFetch('PUT', url, JSON.stringify({}), (json) => {
        dispatch({
          type: 'EXPORT_SERIAL_NO_LIST',
          payload: json
        });
      });
    }
  }
);

export const restoreCareLabels = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let orderId = payload.orderId;
      let deletedLogId = payload.deletedLogId;
      let url = '/firefighter/label/' + orderId + '/restoreCareLabels/' + deletedLogId;
      authFetch('PUT', url, null, (json) => {
        dispatch({
          type: 'RESTORE_CARE_LABELS',
          payload: json
        });
      });
    }
  }
);

export const findDeletedLogIds = (payload) => (
  (dispatch) => {
    if (payload && payload.orderId && !('' === payload.orderId)) {
      let orderId = payload.orderId;
      let url = '/firefighter/label/' + orderId + '/findDeletedLogIds';
      authFetch('GET', url, null, (json) => {
        dispatch({
          type: 'FIND_LABEL_DELETED_LOG_IDS',
          payload: json
        });
      });
    }
  }
);


// WEBPACK FOOTER //
// ./src/actions/labelActions.js